import { cn } from '@/lib/utils'
import type { MdDocumentSection } from './mdDocumentModel'

export function MdTextOutline({
  sections,
  selectedSectionId,
  onSelectSection,
  selectionDisabled = false,
  className,
}: {
  sections: MdDocumentSection[]
  selectedSectionId?: string
  onSelectSection: (sectionId: string) => void
  selectionDisabled?: boolean
  className?: string
}) {
  return (
    <nav
      aria-label="Document outline"
      aria-disabled={selectionDisabled}
      className={cn('flex flex-col gap-0.5', selectionDisabled && 'pointer-events-none opacity-60', className)}
    >
      {sections.map((section) => {
        const indent = section.level > 0 ? (section.level - 1) * 12 : 0
        const isSelected = section.id === selectedSectionId

        return (
          <button
            key={section.id}
            type="button"
            disabled={selectionDisabled}
            onClick={() => onSelectSection(section.id)}
            className={cn(
              'rounded-md px-2 py-1.5 text-left text-sm transition-colors hover:bg-secondary/60 disabled:cursor-not-allowed',
              isSelected && 'bg-secondary font-medium text-foreground',
              !isSelected && 'text-muted-foreground'
            )}
            style={{ paddingLeft: `${8 + indent}px` }}
          >
            {section.title}
          </button>
        )
      })}
    </nav>
  )
}
